<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Tyrel grew up in central Canada in the Prairie town of Rosetown Saskatchewan. Since 2017, he has been working for Hokkaido University’s Faculty of Education where he currently holds a DX Fellowship. He lives in the city of Sapporo, Japan, where he splits his time between his family and reading and writing history and travel.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?ff36a02a